export default __webpack_public_path__ + "static/media/s3.12f88c1c.jpg";